import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Stack, Typography, Box, FormControl, MenuItem, Button, TextField } from '@mui/material';
import { ifacSecurityURL } from "../../utility/apiURLS";
import { getAuthToken, getcompanyId, getuserId, removeFCMToken } from "../../utility/tokenUtility";
import { useNavigate } from 'react-router-dom';
import { InputAutoComplete } from '../../assets/styled-components/textField';
import { loginSuccess } from '../../redux/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import PageLoader from "../commoncomponents/PageLoader"
import dayjs from "dayjs";
import { useAccess } from '../../AccessContext';
import notificationRepository from '../../api/repositories/notificationRepository';
import { toast, ToastContainer } from 'react-toastify';
import { use } from 'react';

const rearrangeData = (data, valueKey, labelKey) => {
  return data.map(item => ({
    value: item[valueKey],
    label: item[labelKey],
    data: item
  }));
};


const Welcomelist = () => {

  const { updateAccessData } = useAccess();
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const userId = getuserId()
  const [isLoading, setIsLoading] = useState(false)
  const roleName = localStorage.getItem('roleName');
  const [options, setOptions] = useState({
    modules: [],
    companies: [],
    locations: [],
    selectedModule: '',
    selectedCompany: '',
    selectedLocation: '',
  });
  let userID = getuserId();  // Fetch roleName once and trim spaces
  let value = null;



  const fetchLocations = async (companyId) => {
    try {
      const token = getAuthToken('id_token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const userId = localStorage.getItem('UserId');
      const locationsResponse = await axios.get(`${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyId}/${userId}`, config);
      const rearrangedLocations = rearrangeData(locationsResponse.data, 'facilityId', 'facilityName',);

      const roleidresponse = await axios.get(`${ifacSecurityURL}/api/secroleregisters?size=1000`, config);

      const roleid = roleidresponse.data.find(
        role =>
          role.rolename?.toLowerCase() === localStorage.getItem('roleName')?.toLowerCase() &&
          role.companyid?.toLowerCase() === localStorage.getItem('companyId')?.toLowerCase()
      );
      if (roleid) {
        localStorage.setItem('roleId', roleid.id);
      }

      // Get the default selected location
      const selectedLocation = rearrangedLocations.length ? rearrangedLocations[0].value : '';
      const selectedLocationName = rearrangedLocations.length ? rearrangedLocations[0].label : '';

      setOptions(prevOptions => ({
        ...prevOptions,
        locations: rearrangedLocations,
        selectedLocation,
      }));
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };
  const existingData = useSelector((state) => state.authendicationReducer);

  // useEffect(() => {
  const fetchInitialOptions = async () => {
    try {
      const token = getAuthToken('id_token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const userId = localStorage.getItem('UserId');
      localStorage.setItem('facilityId', options.selectedLocation);
      localStorage.setItem('companyId', options.selectedCompany);
      const modulesResponse = await axios.get(`${ifacSecurityURL}/api/GraphApplicationRegister/GetAppRegistrationList`, config);
      const rearrangedModules = rearrangeData(modulesResponse.data, 'id', 'appname');
      const selectedModule = rearrangedModules.length ? rearrangedModules[0].value : '';


      const companiesResponse = await axios.get(`${ifacSecurityURL}/api/GraphUserdetails/GetAllCompanyDetailsByUserId/${userId}?size=1000`, config);
      const rearrangedCompanies = rearrangeData(companiesResponse.data, 'id', 'companyname');
      const selectedCompany = rearrangedCompanies.length ? rearrangedCompanies[0].value : '';

      setOptions(prevOptions => ({
        ...prevOptions,
        modules: rearrangedModules,
        companies: rearrangedCompanies,
        selectedModule,
        selectedCompany,
      }));

      // Fetch initial locations based on the first company in the list
      if (selectedCompany) {
        await fetchLocations(selectedCompany);
      }

    } catch (error) {
      console.error('Error fetching initial data:', error);
    }
  };

  useEffect(() => {
    fetchInitialOptions();

    const lastModifiedStr = localStorage.getItem("LastModified"); // Example: "01/01/2025"

    if (lastModifiedStr) {
      // ✅ Parse DD/MM/YYYY format correctly
      const [day, month, year] = lastModifiedStr.split("/").map(Number);
      const lastModifiedDate = new Date(year, month - 1, day); // JS Date uses 0-based months

      // ✅ Add 90 days to get expiration date
      const expirationDate = new Date(lastModifiedDate);
      expirationDate.setDate(expirationDate.getDate() + 90);

      // ✅ Get today's date and ensure both have no time component
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      expirationDate.setHours(0, 0, 0, 0);

      // ✅ Calculate exact difference in days
      const diffInDays = Math.ceil((expirationDate - today) / (1000 * 60 * 60 * 24)); // Use CEIL to fix issue

      // console.log(`Last Modified: ${lastModifiedStr}`);
      // console.log(`Expiry Date: ${expirationDate.toLocaleDateString()}`);
      // console.log(`Days Left: ${diffInDays}`);

      // ✅ Show correct notification based on remaining days
      if (diffInDays > 0 && diffInDays <= 7) {
        toast.warning(
          <b>
            Your password will expire in {diffInDays} {diffInDays === 1 ? "day" : "days"}! Please change your password.
          </b>,
          {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            onClick: () => {
              // Handle the onClick event, for example, redirect to password change page
              navigate('/Expiredchangepassword'); // Redirect to change password page
            }
          }
        );
      } else if (diffInDays === 0) {
        toast.error(
          <b>Your password will expire Today! Please change your password.</b>,
          {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            onClick: () => {
              // Handle the onClick event, for example, redirect to password change page
              navigate('/Expiredchangepassword'); // Redirect to change password page
            }
          }
        );
      } else if (diffInDays < 0) {
        toast.error(
          <b>Your password is expired! Please click 'Continue' to change your password.</b>,
          {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            onClick: () => {
              // Handle the onClick event, for example, redirect to password change page
              navigate('/Expiredchangepassword'); // Redirect to change password page
            }
          }
        );
      }
    }
  }, []);



  const handleCompanyChange = async (e) => {
    const selectedCompany = e.target.value;
    setOptions(prevOptions => ({
      ...prevOptions,
      selectedCompany,
    }));
    await fetchLocations(selectedCompany);
  };

  useEffect(() => {

    dispatch(loginSuccess('LOGIN_SUCCESS', { ...existingData, facilityId: options.selectedLocation, companyId: options.selectedCompany }));


  }, [options.selectedLocation, options.selectedCompany])

  const handleLocationChange = (e) => {
    const selectedLocation = e.target.value;
    setOptions(prevOptions => ({
      ...prevOptions,
      selectedLocation,
    }));
  };



  const [datetime, setDateTime] = useState(dayjs().format("YYYY-MM-DDTHH:mm:ss"));


  const handleSubmit = async () => {

    const token = localStorage.getItem("id_token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const endpoint = `${ifacSecurityURL}/api/secuserloginstatuses`;
    const postData = {
      companyid: options.selectedCompany,
      userid: localStorage.getItem("UserId"),
      id: "",
      logindate: datetime,
    };

    try {
      // ✅ Check password expiration before proceeding
      const lastModifiedStr = localStorage.getItem("LastModified"); // Format: DD/MM/YYYY

      if (lastModifiedStr) {
        const [day, month, year] = lastModifiedStr.split("/").map(Number);
        const lastModifiedDate = new Date(year, month - 1, day);

        // ✅ Add 90 days to the last modified date
        const expirationDate = new Date(lastModifiedDate);
        expirationDate.setDate(expirationDate.getDate() + 90);

        // ✅ Get today's date without time
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expirationDate.setHours(0, 0, 0, 0);

        // ✅ Calculate days difference
        const diffInDays = Math.round((expirationDate - today) / (1000 * 60 * 60 * 24));

        // ✅ If password expired, navigate to change password page
        if (diffInDays < 0) {
          navigate("/Expiredchangepassword");
          return; // Stop further execution
        }
      }

      // ✅ Submit login status
      await axios.post(endpoint, postData, config);
      const roleId = localStorage.getItem("roleId");
      const roleName = localStorage.getItem("roleName"); // Ensure roleName is retrieved

      // ✅ Role-based navigation
      if (roleName === "Vendors") {
        navigate("/VendorDashboard");
      } else if (roleName === "DeptUser") {
        navigate("/Userdeptdashboard");
      } else {
        await fetchAccess(options.selectedCompany, roleId, options.selectedModule);
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  const fetchAccess = async (companyId, roleId, appId) => {
    setIsLoading(true)

    try {
      // Obtain the bearer token and companyId
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // Fetch from API
      const response = await axios.get(
        `${ifacSecurityURL}/api/GraphAccessRightsMapping/GetSecaccessrightmappingUpdatedListFetch/${companyId}/${roleId}/${appId}?size=1000`,
        config
      )

      updateAccessData(response.data)

      // Process fetched access data
      // processAccessData(fetchedAccessData);
    } catch (error) {
      console.error("Error fetching access data:", error);
    }
    finally {
      setIsLoading(false)
    }

  };


  const handleBack = async () => {
    navigate('/');
    await notificationRepository?.getFcmToken(userID, value);
    removeFCMToken('fcmToken');
  };

  localStorage.setItem('facilityId', options.selectedLocation);
  localStorage.setItem('companyId', options.selectedCompany);
  localStorage.setItem('FacilityName', options.locations.find(location => location.value === options.selectedLocation)?.label);
  localStorage.setItem('Facilitycodedata', options.locations.find(location => location.value === options.selectedLocation)?.data?.facilitycode);
  localStorage.setItem('module', options.selectedModule);



  const isButtonDisabled = options.selectedModule === '' || options.selectedCompany === '' || options.selectedLocation === '';

  return (
    <>
      <ToastContainer />
      <Stack pt={{ xs: 4, sm: 0 }} direction={'column'} spacing={2} height={'100%'} >
        <Box textAlign={'center'}>
          <Typography variant='h1' color={'text.secondary'}>Welcome {localStorage.getItem('UserName')}</Typography>
          <Typography fontSize={16}>Please select and continue</Typography>
        </Box>
        <Box>
          <FormControl fullWidth>
            <Typography mb={1} variant='label' color={'text.primary'} component={'label'}>Module</Typography>
            <TextField
              select
              value={options.selectedModule}
              onChange={(e) => setOptions({ ...options, selectedModule: e.target.value })}
              SelectProps={{
                native: false,
              }}
              theme={InputAutoComplete}
            >
              {options.modules.length > 0 ? (
                options.modules.map((module) => (
                  <MenuItem key={module.value} value={module.value}>
                    {module.label}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>
                  No options
                </MenuItem>
              )}
            </TextField>
          </FormControl>
        </Box>
        <Box>
          <FormControl fullWidth>
            <Typography mb={1} variant='label' color={'text.primary'} component={'label'}>Company</Typography>
            <TextField
              select
              value={options.selectedCompany}
              onChange={handleCompanyChange}
              SelectProps={{
                native: false,
              }}
              theme={InputAutoComplete}
            >
              {options.companies.map((company) => (
                <MenuItem key={company.value} value={company.value}>
                  {company.label}
                </MenuItem>
              ))}
              {options.companies.length === 0 && (
                <MenuItem value="" disabled>
                  No options
                </MenuItem>
              )}
            </TextField>
          </FormControl>
        </Box>
        <Box>
          <FormControl fullWidth>
            <Typography mb={1} variant='label' color={'text.primary'} component={'label'}>Location</Typography>
            <TextField
              select
              value={options.selectedLocation}
              onChange={handleLocationChange}
              SelectProps={{
                native: false,
              }}
              theme={InputAutoComplete}
            >
              {options.locations.map((location) => (
                <MenuItem key={location.value} value={location.value}>
                  {location.label}
                </MenuItem>
              ))}
              {options.locations.length === 0 && (
                <MenuItem value="No Options" disabled>
                  No options
                </MenuItem>
              )}
            </TextField>
          </FormControl>
        </Box>
        <Box>
          <FormControl fullWidth>
            <Typography mb={1} variant='label' color={'text.primary'} component={'label'}>Role Name</Typography>
            <TextField
              value={roleName}
              disabled={true}
              theme={InputAutoComplete}
            />
          </FormControl>
        </Box>
        <Stack sx={{ marginTop: '40px !important' }} direction={'row'} gap={2}>
          <Button fullWidth variant='contained' color='primary' disabled={isButtonDisabled} onClick={handleSubmit}>Continue</Button>{" "}
          <Button fullWidth variant='outlined' color='primary' onClick={handleBack}>Back</Button>
        </Stack>
        <PageLoader open={isLoading} />
      </Stack>
    </>
  );
};

export default Welcomelist;
